// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sO5O","left":"styles_left__1u8Qu"};